import { render, staticRenderFns } from "./_integratedInfoBase.vue?vue&type=template&id=4e6835e6&"
import script from "./_integratedInfoBase.vue?vue&type=script&lang=ts&"
export * from "./_integratedInfoBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports